export default __webpack_public_path__ + "static/media/logo.cba3cc6c.png";